import {
  useEffect,
  useContext,
  useRef,
} from 'react';

import PropTypes from 'prop-types';
import { MediaContext } from '@playbookux/playbook-web-core';

import VjsFiller from './vjs-filler';

const Filler = (props) => {
  const {
    startTime,
    endTime,
  } = props;

  const { player } = useContext(MediaContext);

  const fillerEl = useRef(null);

  useEffect(() => {
    fillerEl.current = new VjsFiller(player);

    player.controlBar.progressControl.seekBar.addChild(fillerEl.current);

    return () => {
      player.controlBar.progressControl.seekBar.removeChild(fillerEl.current);
    };
  }, [player]);

  useEffect(() => {
    if (fillerEl.current) {
      fillerEl.current.setTimeSpan(startTime, endTime);
    }
  }, [startTime, endTime]);

  return null;
};

Filler.propTypes = {
  startTime: PropTypes.number.isRequired,
  endTime: PropTypes.number.isRequired,
};

export default Filler;
